var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryCopyrights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1663 9.99999L11.336 12.1661C10.731 12.2871 10.4286 12.3475 10.1822 12.4947C9.96443 12.6247 9.77922 12.8028 9.64067 13.0153C9.48395 13.2556 9.41157 13.5555 9.2668 14.1552L3.83301 36.6667M3.83301 36.6667L26.3444 31.2329C26.9442 31.0881 27.2441 31.0157 27.4844 30.859C27.6969 30.7205 27.8749 30.5352 28.005 30.3175C28.1521 30.0711 28.2126 29.7686 28.3336 29.1636L30.4997 18.3333M3.83301 36.6667L16.4763 24.0233M35.2807 13.1144L27.3853 5.21894C26.7253 4.55892 26.3952 4.2289 26.0147 4.10525C25.68 3.99649 25.3194 3.99649 24.9846 4.10525C24.6041 4.2289 24.2741 4.55892 23.6141 5.21895L22.3853 6.44771C21.7253 7.10774 21.3952 7.43775 21.2716 7.8183C21.1628 8.15304 21.1628 8.51362 21.2716 8.84835C21.3952 9.2289 21.7253 9.55892 22.3853 10.2189L30.2807 18.1144C30.9407 18.7744 31.2708 19.1044 31.6513 19.2281C31.986 19.3368 32.3466 19.3368 32.6814 19.2281C33.0619 19.1044 33.3919 18.7744 34.052 18.1144L35.2807 16.8856C35.9407 16.2256 36.2708 15.8956 36.3944 15.515C36.5032 15.1803 36.5032 14.8197 36.3944 14.485C36.2708 14.1044 35.9407 13.7744 35.2807 13.1144ZM18.833 18.3333C20.674 18.3333 22.1663 19.8257 22.1663 21.6667C22.1663 23.5076 20.674 25 18.833 25C16.9921 25 15.4997 23.5076 15.4997 21.6667C15.4997 19.8257 16.9921 18.3333 18.833 18.3333Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryCopyrights);
export default __webpack_public_path__ + "react/media/category-copyrights.dc317a77cebef6e923004dfe0f1e01c1.svg";
export { ForwardRef as ReactComponent };